import { render, staticRenderFns } from "./Caching.vue?vue&type=template&id=1aaa33c4&"
import script from "./Caching.vue?vue&type=script&lang=js&"
export * from "./Caching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports